/***** DESKTOP *******/
(function ($) {

    const $primaryNav = $('.primary-nav');

    $('.primary-nav > .nav-item > .nav-link').click(function (e) {
        if (!$(this).parent().hasClass('hovered')) {
            e.preventDefault();
        }
    });

    $primaryNav.hoverIntent({
        over: function () {
            //console.log('over primary-nav', this, $(this).attr('data-id'))

            // fade others
            //$('.meganav-dd-wrapper', $primaryNav).fadeOut('fast');

            $(this).addClass('hovered');

            const id = $(this).attr('data-id') || '';
            if (id.length > 0) {
                const $megaWrap = $('.meganav-dd-wrapper[data-parent-id="' + id + '"], .simple-dd[data-parent-id="' + id + '"]');
                if ($megaWrap.length > 0) {
                    $megaWrap.slideDown('fast', 'linear');
                }
            }
        },
        out: function () {

            //console.log('out primary-nav', this, $(this).attr('data-id'))

            $(this).removeClass('hovered');


            const id = $(this).attr('data-id') || '';
            if (id.length > 0) {
                const $megaWrap = $('.meganav-dd-wrapper[data-parent-id="' + id + '"], .simple-dd[data-parent-id="' + id + '"]');
                if ($megaWrap.length > 0) {
                    $megaWrap.slideUp('fast', 'linear', function () {
                        //console.log('height clean');

                        //$megaWrap.attr('data-height-setby', '');
                        $megaWrap.css('height', 'unset');
                    });
                }               
            }
        },
        selector: '> li',
        timeout: 300
    })

    

})(jQuery);

/**** MOBILE ****/
(function ($) {

    const $root = $('#mobileNav');

    $('.navigation-link[data-type="section"]', $root).click(function (e) {
        e.preventDefault();

        // handle active state of navigation column
        $(this).parent().parent().find('.navigation-column.active').removeClass('active');
        $(this).siblings('.navigation-column').addClass('active');

        // enable overlay
        //$overlay.addClass('active');
        //$body.addClass('overflow-hidden');
    });

    $('.navigation-link.mobile-back', $root).click(function () {
        $(this).closest('.navigation-column').removeClass('active');
    });


    $root.on('show.bs.collapse', function () {

        calculateTopForMobileNav();

    })

    $(document).on('si-alert-ribbon-closing', function () {

        calculateTopForMobileNav(true);

    });

    function calculateTopForMobileNav(excludeAlertRibbon) {

        var alertRibbonHeight = excludeAlertRibbon ? 0 : $('.alert-ribbon:visible').outerHeight() || 0;
        var preaheaderHeight = $('.preheader').outerHeight() || 0;
        var topHeaderNavbar = $('#top-header-navbar').outerHeight() || 0;

        var topValue = alertRibbonHeight + preaheaderHeight + topHeaderNavbar + 'px';

        $root.animate({
            top: topValue
        }, 'fast', 'linear');       
    }

})(jQuery);

